import React from 'react';
import classNames from 'classnames';

import Cell from './Cell';
import ScopeRow from './ScopeRow';

import { RowDecorator } from '../../../Enum/TableDecorator';
import { Row as RowInterface } from '../../../Interface/Hook/Interest/InterestTableDTO';

import { getDeviationColor } from '../../../Helpers/Color';
import { useIsScopeClosed } from '../../../Hook/Interest/UseIsScopeClosed';

interface Props {
    data: RowInterface;
}

const Row: React.FC<Props> = ({ data }: Props) => {
    const scopeClosed = useIsScopeClosed(data.scope);

    if (data.decorator === RowDecorator.ScopeRow) {
        return <ScopeRow data={data} />;
    }

    return (
        <tr className={classNames({ 'd-none': scopeClosed }, getDeviationColor(data.cells))} data-testid="table-row">
            {data.cells.map((cell, index) => (
                <Cell cell={cell} key={index} />
            ))}
        </tr>
    );
};

export default Row;
